import React from "react";
import IOrder from "../../../models/IOrder";
import OwLabel from "../../shared/OwLabel/OwLabel";
import IShipment from "../../../models/IShipment";
import UserService from "../../../services/UserService";
import { Link, useNavigate } from "react-router-dom";
import OwButton from "../../shared/OwButton/OwButton";
import OwPill from "../../shared/OwPill/OwPill";

type Props = {
    order: IOrder;
    isReadOnly: boolean;
};

export const OrderEntryShipmentsPanel = (props: Props) => {
    const navigate = useNavigate();

    const getShipmentRow = (index: number, detail: { shipmentGroup: { id: number; guid: string }; shipment: IShipment }) => {
        const tracking = detail.shipment.tracking?.length ? detail.shipment.tracking : "No Tracking Number";

        const carrier = detail.shipment.Shipping_Carrier?.name || "";

        const shippingDate = UserService.parseDate(detail.shipment.shipment_date || "");

        const rowItems: string[] = [carrier, tracking];

        return (
            <div className={"border border-dark-subtle border-1 rounded p-2 mb-2"}>
                <div className={"d-flex"}>
                    <b>
                        <OwLabel title={"shipment"} className={"me-2"} />#{index + 1}
                    </b>{" "}
                    {rowItems.map((item) => {
                        return (
                            <div key={item} className={"ps-2 pe-2 ms-2 border border-dark-subtle border-1 rounded-5 text-small"}>
                                <b>{item}</b>
                            </div>
                        );
                    })}
                </div>
                <div className={"text-small text-muted"}>{shippingDate}</div>
            </div>
        );
    };

    const viewShipments = () => {
        const url = `/shipments?order=${props.order.name}&has_shipments=&offset=0&limit=5`;

        navigate(url);
    };

    return (
        <div className={"OrderEntryShipmentsPanel"}>
            <div className="panel panel-default p-2">
                <OwButton title={"view_shipments"} fn={viewShipments} className={"btn-primary"} leftIconClass={"fas fa-magnifying-glass"} />
                {/*<Link to={`/shipments?order=${props.order.name}&has_shipments=&offset=0&limit=5`}><OwLabel title={"view_shipments"} className={"pointer"}/></Link>*/}
                <div className="panel-body mt-2">
                    {props.order.Shipments?.map((shipmentDetail, index) => {
                        return getShipmentRow(index, shipmentDetail);
                    })}
                    {!props.order.Shipments?.length && (
                        <div className="">
                            <OwLabel title={"no_shipments_found"} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
